/* globals document, window */

const {
	prepareSearchResults,
} = require('public/js/search-helper');

const THE_SCRIPT = function () {
	const $onReady = require('./lib/on-ready');

	$onReady({rp$, window,
		label: 'search',
		fn: function() {
			loadSearch();
		},
	});

	function loadSearch() {
		prepareSearchResults();
	}
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
